<template>
  <div class="home">
    <!-- <iframe ref="ifr" src="https://badabusiness.com/dd/BIMK003866" height="100%" width="100%"/> -->

    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  created() {
    location = 'https://badabusiness.com/dd/BIMK003866'
  },
  mounted(){
    let ifr = this.$refs.ifr.contentDocument;
    console.log(ifr.body);
    ifr.body.querySelector('.connect > li:nth-child(2)').style.display = 'none';
  },
  methods: {

  }
}
</script>

<style scoped>
  iframe {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
</style>
